import { toast } from "react-toastify";

export const API_ERROR = {
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
};

export function handleApiError(error, clearUserCallback) {
  // Handle undefined or null error
  if (!error) {
    const errorMessage = "An unknown error occurred";
    toast.error(errorMessage, { position: toast.POSITION.BOTTOM_RIGHT });
    return {
      data: {
        object: null,
        Errors: [{ Description: errorMessage }],
        succeeded: false,
      },
    };
  }

  if (error.response && error.response.status === API_ERROR.UNAUTHORIZED) {
    // Clear user from context
    if (clearUserCallback) {
      clearUserCallback();
    }
    // Redirect to our custom login page instead of Auth0
    window.location.hash = "#/login";
    return {
      data: {
        object: null,
        Errors: [{ Description: "Session expired. Please log in again." }],
        succeeded: false,
      },
    };
  }
  if (error.response && error.response.status === API_ERROR.FORBIDDEN) {
    const errorMessage =
      "Your user doesn't have permissions to execute this action.";
    toast.error(errorMessage, { position: toast.POSITION.BOTTOM_RIGHT });
    return {
      data: {
        object: null,
        Errors: [{ Description: errorMessage }],
        succeeded: false,
      },
    };
  }
  if (error.response && error.response.status === API_ERROR.BAD_REQUEST) {
    const responseData = error.response.data;
    const errorMessage = responseData?.detail || "Bad request";
    toast.error(errorMessage, { position: toast.POSITION.BOTTOM_RIGHT });
    return {
      data: {
        object: null,
        Errors: [{ Description: errorMessage }],
        succeeded: false,
      },
    };
  }
  let message = error.message || error.toString() || "An error occurred";
  toast.error(message, { position: toast.POSITION.BOTTOM_RIGHT });
  return {
    data: {
      object: null,
      Errors: [{ Description: message }],
      succeeded: false,
    },
  };
}
